module.exports = {
	"order_exports": {
		"id": "ID",
		"created_at": "Created at",
		"period": "Period",
		"status": {
			"title": "Status",
			"new": "New",
			"in_progress": "In progress",
			"completed": "Completed",
			"canceled": "Canceled",
			"expired": "Expired"
		},
		"actions": "Actions",
		"progress_percent": "Progress",
		"eta": "ETA",
		"time": "~ {hours}h {minutes}m {seconds}s",
		"cancel": "Cancel",
		"download": "Download",
		"added_to": "Report added to",
		"queue": "download queue",
		"refresh": "Refresh results"
	}
};